import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
import {IconSection} from 'shells/icon-section/icon-section';
import {Body} from 'shells/typography/body';

import type {
    GetContextDocuments_contextDocuments_aiSuggestions as AiSuggestion,
    ChatSettingsKnowledgeFragment_lookAndFeel as LookAndFeel,
} from 'nutshell-graphql-types';

import {AiSuggestionsList} from './ai-suggestions-list';

type Props = {
    aiSuggestions: AiSuggestion[];
    lookAndFeel: LookAndFeel;
};

export function AiSuggestionsContent(props: Props) {
    return (
        <>
            <IconSection
                icon={AiSparkleNewIcon}
                iconColor={colors.plum}
                fullWidth={true}
                marginTopValue={2}
                gap={4}
            >
                <Body size='small' color='plum'>
                    AI suggestions
                </Body>
            </IconSection>
            <AiSuggestionsList
                aiSuggestions={props.aiSuggestions}
                lookAndFeel={props.lookAndFeel}
            />
        </>
    );
}
